import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/shop/xbox.svg'
import _imports_1 from '@/assets/shop/playstation.svg'


const _withScopeId = n => (_pushScopeId("data-v-392cd700"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "image" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "description" }
const _hoisted_5 = { class: "price-wrapper" }
const _hoisted_6 = { class: "price" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "currency" }, "EUR", -1))
const _hoisted_8 = { class: "shop-now" }
const _hoisted_9 = { class: "detailed-container" }
const _hoisted_10 = { class: "image-wrapper" }
const _hoisted_11 = { class: "detailed-image" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "icons-wrapper" }
const _hoisted_14 = {
  key: 0,
  class: "icon"
}
const _hoisted_15 = {
  key: 1,
  class: "icon"
}
const _hoisted_16 = { key: 2 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"height":"24px"},
  src: _imports_0
}, null, -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { key: 3 }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"height":"24px"},
  src: _imports_1
}, null, -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = { class: "description-wrapper" }
const _hoisted_23 = { class: "description-content" }
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = { class: "description-price" }
const _hoisted_26 = { class: "price" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "currency" }, "EUR", -1))
const _hoisted_28 = { class: "add-to-card" }
const _hoisted_29 = { class: "slider-image" }
const _hoisted_30 = ["src"]
const _hoisted_31 = { class: "slider-price" }
const _hoisted_32 = { class: "price" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "currency" }, "EUR", -1))
const _hoisted_34 = { class: "slider-button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_common_label = _resolveComponent("common-label")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle(_ctx.cssProps)
  }, [
    (_ctx.shop != undefined && _ctx.type == 'highlighted')
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "shop-card",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$router.push({ name: 'ShopItem', params: { id: _ctx.shop.id } })), ["stop"]))
        }, [
          (_ctx.label != undefined)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_common_label, {
                  colorTop: _ctx.mainColor,
                  colorBottom: _ctx.secondaryColor,
                  text: _ctx.label,
                  class: "label"
                }, null, 8, ["colorTop", "colorBottom", "text"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("img", {
              src: _ctx.shop.highlightedImage
            }, null, 8, _hoisted_3)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", null, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.shop.price.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })), 1),
                _hoisted_7
              ])
            ]),
            _createElementVNode("button", _hoisted_8, _toDisplayString(_ctx.t("shop.shop-now")), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.shop != undefined && _ctx.type == 'detailed')
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "detailed-shop-card",
          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.$router.push({ name: 'ShopItem', params: { id: _ctx.shop.id } })), ["stop"]))
        }, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("img", {
                  src: _ctx.shop.image
                }, null, 8, _hoisted_12)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", null, [
                  (_ctx.shop.tags.includes('desktop') || _ctx.shop.tags.length == 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createVNode(_component_font_awesome_icon, {
                          icon: ['fa', 'desktop'],
                          size: "lg",
                          class: "icon"
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.shop.tags.includes('gift'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _createVNode(_component_font_awesome_icon, {
                          icon: ['fa', 'gift'],
                          size: "lg",
                          class: "icon"
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.shop.tags.includes('xbox'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_18))
                    : _createCommentVNode("", true),
                  (_ctx.shop.tags.includes('playstation'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_21))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("span", {
                  class: "content",
                  innerHTML: _ctx.shop.description
                }, null, 8, _hoisted_24)
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.shop.price.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })), 1),
                _hoisted_27
              ]),
              _createElementVNode("div", {
                class: "description-button",
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.addToCart()), ["stop"]))
              }, [
                _createElementVNode("button", _hoisted_28, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: ['fa', 'cart-plus'],
                    size: "lg",
                    class: "icon"
                  })
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.type == 'slider' && _ctx.shop != undefined)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "shop-slider-card",
          onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.$router.push({ name: 'ShopItem', params: { id: _ctx.shop.id } })), ["stop"]))
        }, [
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("img", {
              src: _ctx.shop.image
            }, null, 8, _hoisted_30)
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", null, [
              _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.shop.price.toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })), 1),
              _hoisted_33
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("button", {
              class: "add-to-card",
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.addToCart()), ["stop"]))
            }, [
              _createVNode(_component_font_awesome_icon, {
                icon: ['fa', 'cart-plus'],
                size: "lg",
                class: "icon"
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 4))
}